import { Column } from '@stenajs-webui/core';
import { useAllIntermodalRoutesAsOptions } from '../../../../common/graphql/useAllIntermodalRoutesAsOptions';
import { formatServerDate } from '../../../../common/utils/dates/dateUtils';
import { DetailsFieldCell } from '../../../../common-ui/details/DetailsFieldCell';
import { timeOptions } from '../../../manage/details/components/sections/common';
import {
  transformDepartureTimeOption,
  transformIntermodalRouteToDropdownOption,
} from '../../utils/detailsUtils';
import { CreateIntermodalValidationWrapper } from '../CreateIntermodalValidationWrapper';
import { CreateIntermodalDateInputField } from '../fields/CreateIntermodalDateInputField';
import { CreateIntermodalDropdownField } from '../fields/CreateIntermodalDropdownField';
import { IntermodalSearchOptionSwitch } from '../IntermodalSearchOptionSwitch';

export const CreateIntermodalDepartureSection = () => {
  const { intermodalRouteOptions } = useAllIntermodalRoutesAsOptions();
  const today = new Date();
  return (
    <>
      <CreateIntermodalValidationWrapper
        name={'route'}
        renderField={isValid => (
          <DetailsFieldCell
            label={'Intermodal route'}
            className={'t_intermodal_route_field'}
            renderField={id => (
              <CreateIntermodalDropdownField
                id={id}
                trackerCategory={'IntermodalCreate'}
                options={intermodalRouteOptions}
                name={'route'}
                transformOption={transformIntermodalRouteToDropdownOption}
                isValid={isValid}
              />
            )}
          />
        )}
      />
      <IntermodalSearchOptionSwitch />
      <Column gap={2}>
        <CreateIntermodalValidationWrapper
          name={'departureDate'}
          renderField={isValid => (
            <DetailsFieldCell
              label={'Date'}
              className={'t_intermodal_date_field'}
              renderField={id => (
                <CreateIntermodalDateInputField
                  id={id}
                  width={'100%'}
                  trackerCategory={'IntermodalCreate'}
                  name={'departureDate'}
                  isValid={isValid}
                  minDate={formatServerDate(today)}
                />
              )}
            />
          )}
        />
        <CreateIntermodalValidationWrapper
          name={'departureTime'}
          renderField={isValid => (
            <DetailsFieldCell
              label={'Time'}
              renderField={id => (
                <CreateIntermodalDropdownField
                  id={id}
                  trackerCategory={'IntermodalCreate'}
                  name={'departureTime'}
                  options={timeOptions}
                  transformOption={transformDepartureTimeOption}
                  isValid={isValid}
                />
              )}
            />
          )}
        />
      </Column>
    </>
  );
};
